import { render } from "./MyLoanBankView.vue?vue&type=template&id=531a8859&scoped=true"
import script from "./MyLoanBankView.vue?vue&type=script&lang=js"
export * from "./MyLoanBankView.vue?vue&type=script&lang=js"

import "./MyLoanBankView.vue?vue&type=style&index=0&id=531a8859&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531a8859"]])

export default __exports__